import * as R from 'ramda';
import { sortStringsAphabetically } from './sortStringsAphabetically';

export const flattenAccessScopes = (selectedAccessGroupScopes): string[] => {
  const accessScopes = R.filter(scopes => Boolean(scopes), R.values(selectedAccessGroupScopes));

  return sortStringsAphabetically(accessScopes);
};
